var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"home-container",attrs:{"grid-list-xs":""}},[_c('Fields',{attrs:{"group-id":"Home","fields":_vm.readFields,"filters":_vm.searchFields,"readonly":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }